(() => {
  const STORAGE_KEY = 'irp-payment-price-mode-v1';
  const TRANSFER_MODE = 'transfer';
  const LIST_MODE = 'list';
  const DEFAULT_DISCOUNT_PERCENT = 15;
  const STORAGE_DURATION = 90 * 24 * 60 * 60 * 1000;
  const SCALA_READY_TIMEOUT = 4000;
  const SCALA_READY_INTERVAL = 200;
  const SCALA_BUTTON_TEXT = /(checkout with discount|checkout con descuento|pagar con descuento|pagar por transferencia)/i;
  const CHECKOUT_CANDIDATE_SELECTOR = 'button, input[type="submit"], a, [role="button"]';
  const SCALA_HOST_SELECTOR = [
    '[id*="scala" i]',
    '[class*="scala" i]',
    '[id*="discounted-cart" i]',
    '[class*="discounted-cart" i]',
    '[data-testid*="discounted-cart" i]',
  ].join(',');
  let commercialConfiguration = null;
  let commercialConfigurationRequest = null;

  const currency = window.Shopify?.currency?.active || 'ARS';
  const formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
  });
  const wholeCurrencyFormatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    maximumFractionDigits: 0,
  });

  const formatMoney = (cents) => formatter.format(Number(cents || 0) / 100).replace(/\u00a0/g, ' ');
  const discountPercent = () => {
    const configured = Number(document.querySelector('[data-irp-payment-mode-selector]')?.dataset.irpDiscountPercent);
    return Number.isFinite(configured) ? Math.min(50, Math.max(0, configured)) : DEFAULT_DISCOUNT_PERCENT;
  };
  const transferPrice = (cents) => Math.round(Number(cents || 0) * (1 - discountPercent() / 100));
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const storefrontApiUrl = () => {
    if (location.hostname === '127.0.0.1' || location.hostname === 'localhost') {
      return new URLSearchParams(location.search).get('irpMock') === '1'
        ? 'http://127.0.0.1:3005/v1/ecommerce/compatibilidades'
        : 'http://127.0.0.1:3001/v1/ecommerce/compatibilidades';
    }
    return '/apps/irp-compatibilidades';
  };

  const renderCommercialActionLink = (collection) => {
    const collectionUrl = typeof collection?.url === 'string' && /^\/collections\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(collection.url)
      ? collection.url
      : null;
    document.querySelectorAll('[data-irp-commercial-action-link]').forEach((link) => {
      if (!collectionUrl) {
        link.hidden = true;
        return;
      }
      link.href = collectionUrl;
      link.hidden = false;
    });
  };

  const loadCommercialConfiguration = () => {
    if (commercialConfigurationRequest) return commercialConfigurationRequest;
    commercialConfigurationRequest = fetch(`${storefrontApiUrl()}/shopify/configuracion-comercial`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('No se pudo cargar la configuración comercial.');
        return response.json();
      })
      .then((payload) => {
        renderCommercialActionLink(payload?.activeOfferCollection || null);
        commercialConfiguration = payload?.active ? payload : null;
        renderInstallmentPrices();
        renderFreeShippingAnnouncements();
        renderFreeShippingPills();
        renderShippingProgress();
        return commercialConfiguration;
      })
      .catch(() => {
        renderCommercialActionLink(null);
        return null;
      });
    return commercialConfigurationRequest;
  };

  const financingOptionFor = (cents, fallbackInstallments) => {
    const priceArs = Number(cents || 0) / 100;
    const configuredOption = [...(commercialConfiguration?.financingOptions || [])]
      .filter((option) => !option.minimumPurchaseArs || priceArs >= Number(option.minimumPurchaseArs))
      .sort((left, right) => Number(right.installments) - Number(left.installments))[0] || null;
    if (configuredOption) return configuredOption;
    const installments = Number(fallbackInstallments || 0);
    return installments > 0 ? { installments } : null;
  };

  const renderInstallmentPrices = (scope = document) => {
    const maxInstallments = Number(commercialConfiguration?.maxInstallments || 0);
    if (maxInstallments) {
      document.querySelectorAll('[data-irp-installments-copy]').forEach((element) => {
        setText(element, `${maxInstallments} cuotas sin interés`);
      });
    }

    scope.querySelectorAll('[data-irp-installment-pill]').forEach((pill) => {
      const root = pill.closest('[data-irp-price-root]');
      const cents = Number(root?.dataset.irpPriceCents || 0);
      const option = financingOptionFor(cents, root?.dataset.irpInstallmentsFallback);
      if (!option || !cents) {
        pill.hidden = true;
        return;
      }
      const installmentCents = Math.round(cents / Number(option.installments));
      setText(pill, `EN ${option.installments} CUOTAS DE ${formatMoney(installmentCents)} SIN INTERÉS`);
      pill.hidden = false;
    });
  };

  const renderFreeShippingAnnouncements = () => {
    const thresholdArs = Number(commercialConfiguration?.freeShipping?.thresholdArs || 0);
    if (!Number.isFinite(thresholdArs) || thresholdArs <= 0) return;
    const copy = `Envío gratis desde ${wholeCurrencyFormatter.format(thresholdArs).replace(/\u00a0/g, ' ')}`;
    document.querySelectorAll('[data-irp-free-shipping-copy]').forEach((element) => setText(element, copy));
  };

  const normalizedTags = (values) => (Array.isArray(values) ? values : [])
    .map((value) => String(value || '').trim().toLowerCase())
    .filter(Boolean);

  const renderFreeShippingPills = (scope = document) => {
    const configuration = commercialConfiguration?.freeShipping;
    const thresholdArs = Number(configuration?.thresholdArs || 0);
    if (!Number.isFinite(thresholdArs) || thresholdArs <= 0) return;
    const thresholdCents = Math.round(thresholdArs * 100);
    const includedTags = normalizedTags(configuration?.includedTags);
    const excludedTags = normalizedTags(configuration?.excludedTags);

    scope.querySelectorAll('[data-irp-free-shipping-pill]').forEach((pill) => {
      const priceCents = Number(pill.dataset.irpProductPriceCents || 0);
      let productTags = [];
      try {
        productTags = normalizedTags(JSON.parse(pill.dataset.irpProductTags || '[]'));
      } catch (_error) {
        productTags = [];
      }
      const included = productTags.some((tag) => includedTags.includes(tag));
      const excluded = !included && productTags.some((tag) => excludedTags.includes(tag));
      pill.hidden = !priceCents || priceCents < thresholdCents || excluded;
    });
  };

  const renderShippingProgress = (scope = document) => {
    scope.querySelectorAll('[data-irp-shipping-progress]').forEach((root) => {
      const fallbackThresholdCents = Number(root.dataset.irpThresholdFallbackCents || 0);
      const configuredThresholdArs = Number(commercialConfiguration?.freeShipping?.thresholdArs || 0);
      const thresholdCents = configuredThresholdArs > 0
        ? Math.round(configuredThresholdArs * 100)
        : fallbackThresholdCents;
      const eligibleTotalCents = Number(root.dataset.irpEligibleTotalCents || 0);
      if (!thresholdCents) return;

      const remainingCents = Math.max(0, thresholdCents - eligibleTotalCents);
      const complete = remainingCents === 0;
      const title = root.querySelector('[data-irp-shipping-progress-title]');
      const detail = root.querySelector('[data-irp-shipping-progress-detail]');
      const track = root.querySelector('[data-irp-shipping-progress-track]');
      const fill = root.querySelector('.irp-shipping-progress__fill');
      const progress = Math.min(100, (eligibleTotalCents * 100) / thresholdCents);

      root.classList.toggle('irp-shipping-progress--complete', complete);
      setText(title, complete
        ? '¡Alcanzaste el envío gratis!'
        : `Te faltan ${formatMoney(remainingCents)} para el envío gratis.`);
      if (detail) detail.hidden = !complete;
      if (track) {
        track.setAttribute('aria-valuemax', String(thresholdCents));
        track.setAttribute('aria-valuenow', String(Math.min(eligibleTotalCents, thresholdCents)));
        track.setAttribute('aria-valuetext', complete
          ? 'Umbral de envío gratis alcanzado'
          : `Faltan ${formatMoney(remainingCents)}`);
      }
      if (fill) fill.style.setProperty('--irp-shipping-progress', `${progress}%`);
    });
  };

  const readMode = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!stored || stored.expiresAt <= Date.now()) return TRANSFER_MODE;
      return stored.mode === LIST_MODE ? LIST_MODE : TRANSFER_MODE;
    } catch (_error) {
      return TRANSFER_MODE;
    }
  };

  const storeMode = (mode) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ mode, expiresAt: Date.now() + STORAGE_DURATION }));
    } catch (_error) {
      // La preferencia visual no debe bloquear la compra si el storage no está disponible.
    }
  };

  const renderProductPrices = (scope = document) => {
    scope.querySelectorAll('[data-irp-price-root]').forEach((root) => {
      const cents = Number(root.dataset.irpPriceCents || 0);
      const original = root.querySelector('[data-irp-transfer-original]');
      const discounted = root.querySelector('[data-irp-transfer-price]');
      if (!cents || !original || !discounted) return;
      setText(original, formatMoney(cents));
      setText(discounted, formatMoney(transferPrice(cents)));
    });
    renderInstallmentPrices(scope);
  };

  const ensureCartLinePrice = (wrapper) => {
    const cents = Number(wrapper.dataset.irpCartLinePrice || 0);
    if (!cents) return;
    let transfer = wrapper.querySelector('.irp-transfer-cart-price');
    if (!transfer) {
      transfer = document.createElement('span');
      transfer.className = 'irp-transfer-cart-price';
      transfer.innerHTML = '<s data-irp-transfer-original></s><strong data-irp-transfer-price></strong>';
      wrapper.append(transfer);
    }
    setText(transfer.querySelector('[data-irp-transfer-original]'), formatMoney(cents));
    setText(transfer.querySelector('[data-irp-transfer-price]'), formatMoney(transferPrice(cents)));
  };

  const ensureCartSummary = (totals) => {
    const cents = Number(totals.dataset.irpCartTotal || 0);
    if (!cents) return;
    const rail = totals.closest('.drawer__footer')?.querySelector('[data-irp-cart-summary-rail]');
    const summaryHost = rail || totals.parentElement;
    let summary = summaryHost?.querySelector('.irp-transfer-cart-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'irp-transfer-cart-summary';
      summary.setAttribute('aria-live', 'polite');
      summary.innerHTML = [
        '<span class="irp-transfer-cart-summary__label">Total por transferencia</span>',
        '<span class="irp-transfer-cart-summary__meta"><s data-irp-transfer-original></s><span class="irp-transfer-cart-summary__saving">Ahorrás <strong data-irp-transfer-saving></strong></span></span>',
        '<span class="irp-transfer-cart-summary__bottom"><strong class="irp-transfer-cart-summary__price" data-irp-transfer-price></strong><span class="irp-transfer-pill" data-irp-transfer-pill></span></span>',
      ].join('');
      if (rail) rail.prepend(summary);
      else totals.insertAdjacentElement('afterend', summary);
    }
    setText(summary.querySelector('[data-irp-transfer-original]'), formatMoney(cents));
    setText(summary.querySelector('[data-irp-transfer-price]'), formatMoney(transferPrice(cents)));
    setText(summary.querySelector('[data-irp-transfer-saving]'), formatMoney(cents - transferPrice(cents)));
    setText(summary.querySelector('[data-irp-transfer-pill]'), discountPercent() + '% OFF POR TRANSFERENCIA');
  };

  const renderCartPrices = (scope = document) => {
    scope.querySelectorAll('[data-irp-cart-line-price]').forEach(ensureCartLinePrice);
    scope.querySelectorAll('[data-irp-cart-total]').forEach(ensureCartSummary);
  };

  const buttonText = (element) => (element.textContent || element.value || '').trim();

  const markScalaButtons = () => {
    const nativeButtons = new Set(document.querySelectorAll('[data-irp-native-checkout-target]'));
    const scalaButtons = new Set(document.querySelectorAll('[data-irp-scala-checkout]'));
    document.querySelectorAll(CHECKOUT_CANDIDATE_SELECTOR).forEach((element) => {
      if (
        nativeButtons.has(element) ||
        element.closest('[data-irp-payment-mode-selector]') ||
        element.closest('[data-irp-checkout-cta]')
      ) {
        return;
      }
      if (element.querySelector(CHECKOUT_CANDIDATE_SELECTOR)) return;

      const parent = element.parentElement;
      const signature = [
        element.id,
        element.className,
        element.getAttribute('data-testid') || '',
        parent?.id || '',
        parent?.className || '',
      ].join(' ');
      if (/scala|discounted.?cart|payment.?discount/i.test(signature) || SCALA_BUTTON_TEXT.test(buttonText(element))) {
        element.dataset.irpScalaCheckout = 'true';
        scalaButtons.add(element);
      }
    });

    document.querySelectorAll(SCALA_HOST_SELECTOR).forEach((host) => {
      if (!host.closest('.drawer__footer, .cart__blocks')) return;
      if (host.matches('[data-irp-checkout-cta], [data-irp-native-checkout-target]')) return;
      if (host.querySelector('[data-irp-checkout-cta], [data-irp-native-checkout-target]')) return;

      host.dataset.irpScalaCheckoutContainer = 'true';
      const shadowButton = host.shadowRoot?.querySelector(CHECKOUT_CANDIDATE_SELECTOR);
      if (shadowButton) scalaButtons.add(shadowButton);
    });

    document.querySelectorAll('iframe').forEach((frame) => {
      if (!frame.closest('.drawer__footer, .cart__blocks')) return;
      const signature = [frame.src, frame.title, frame.id, frame.className].join(' ');
      if (/scala|discounted.?cart|payment.?discount/i.test(signature)) {
        frame.dataset.irpScalaCheckoutContainer = 'true';
      }
    });

    document.documentElement.classList.toggle('irp-scala-checkout-ready', scalaButtons.size > 0);
    scalaButtons.forEach((button) => {
      button.setAttribute('aria-hidden', 'true');
      button.setAttribute('tabindex', '-1');
    });
    return [...scalaButtons];
  };

  const checkoutScope = (element) => element.closest('.drawer__footer, .cart__blocks') || document;

  const firstEnabled = (elements) =>
    elements.find((element) => element.isConnected && !element.disabled && element.getAttribute('aria-disabled') !== 'true');

  const nativeCheckoutFor = (cta) =>
    firstEnabled([...checkoutScope(cta).querySelectorAll('[data-irp-native-checkout-target]')]) ||
    firstEnabled([...document.querySelectorAll('[data-irp-native-checkout-target]')]);

  const scalaCheckoutFor = (cta) => {
    const scalaButtons = markScalaButtons();
    return (
      firstEnabled([...checkoutScope(cta).querySelectorAll('[data-irp-scala-checkout]')]) || firstEnabled(scalaButtons)
    );
  };

  const checkoutErrorFor = (cta) => {
    const group = cta.closest('[data-irp-checkout-choice-group], .irp-checkout-choice-group');
    if (!group) return null;
    let error = group.querySelector('[data-irp-checkout-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'irp-checkout-error';
      error.dataset.irpCheckoutError = 'true';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      group.append(error);
    }
    return error;
  };

  const setCheckoutError = (cta, message = '') => {
    const error = checkoutErrorFor(cta);
    if (!error) return;
    setText(error, message);
    error.hidden = !message;
  };

  const waitForScalaCheckout = async (cta) => {
    const deadline = Date.now() + SCALA_READY_TIMEOUT;
    let scalaCheckout = scalaCheckoutFor(cta);
    while (!scalaCheckout && Date.now() < deadline) {
      await new Promise((resolve) => window.setTimeout(resolve, SCALA_READY_INTERVAL));
      scalaCheckout = scalaCheckoutFor(cta);
    }
    return scalaCheckout;
  };

  const shopRoot = () => window.Shopify?.routes?.root || '/';
  const clearDiscountAndRedirect = (redirectTo) => {
    const clearUrl = `${shopRoot()}discount/CLEAR?redirect=${encodeURIComponent(redirectTo)}`;
    window.location.assign(clearUrl);
  };

  const openCheckout = async (cta) => {
    if (document.documentElement.dataset.irpPaymentMode === TRANSFER_MODE) {
      if (cta.dataset.irpCheckoutPending === 'true') return;
      cta.dataset.irpCheckoutPending = 'true';
      cta.disabled = true;
      cta.setAttribute('aria-busy', 'true');
      setCheckoutError(cta);
      try {
        const scalaCheckout = await waitForScalaCheckout(cta);
        if (scalaCheckout) {
          scalaCheckout.click();
          return;
        }
        setCheckoutError(
          cta,
          'No pudimos iniciar el pago por transferencia. Recargá la página o elegí pagar con tarjeta.'
        );
      } finally {
        delete cta.dataset.irpCheckoutPending;
        cta.disabled = false;
        cta.removeAttribute('aria-busy');
      }
      return;
    }

    const nativeCheckout = nativeCheckoutFor(cta);
    if (!nativeCheckout) return;
    setCheckoutError(cta);
    clearDiscountAndRedirect(`${shopRoot()}checkout`);
  };

  const applyMode = (mode, persist = false) => {
    const normalizedMode = mode === TRANSFER_MODE ? TRANSFER_MODE : LIST_MODE;
    document.documentElement.dataset.irpPaymentMode = normalizedMode;
    document.querySelectorAll('[data-irp-payment-mode-option]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.irpPaymentModeOption === normalizedMode));
    });
    document.querySelectorAll('[data-irp-payment-mode-toggle]').forEach((button) => {
      const label = normalizedMode === TRANSFER_MODE ? 'Ver precio de lista' : 'Ver descuento con transferencia';
      setText(button, label);
      button.setAttribute('aria-label', label);
    });
    renderProductPrices();
    renderCartPrices();
    renderFreeShippingAnnouncements();
    renderFreeShippingPills();
    renderShippingProgress();
    markScalaButtons();
    if (persist) storeMode(normalizedMode);
    document.dispatchEvent(new CustomEvent('irp:payment-mode-change', { detail: { mode: normalizedMode } }));
  };

  document.addEventListener('click', (event) => {
    const modeToggle = event.target.closest('[data-irp-payment-mode-toggle]');
    if (modeToggle) {
      const currentMode = document.documentElement.dataset.irpPaymentMode || readMode();
      applyMode(currentMode === TRANSFER_MODE ? LIST_MODE : TRANSFER_MODE, true);
      return;
    }

    const option = event.target.closest('[data-irp-payment-mode-option]');
    if (option) {
      applyMode(option.dataset.irpPaymentModeOption, true);
      return;
    }

    const checkoutCta = event.target.closest('[data-irp-checkout-cta]');
    if (!checkoutCta || checkoutCta.disabled) return;
    event.preventDefault();
    const checkoutMode = checkoutCta.dataset.irpCheckoutMode;
    if (checkoutMode === TRANSFER_MODE || checkoutMode === LIST_MODE) {
      applyMode(checkoutMode, true);
    }
    void openCheckout(checkoutCta);
  });

  let updateScheduled = false;
  const observer = new MutationObserver(() => {
    if (updateScheduled) return;
    updateScheduled = true;
    requestAnimationFrame(() => {
      updateScheduled = false;
      applyMode(document.documentElement.dataset.irpPaymentMode || readMode());
    });
  });

  const initialize = () => {
    applyMode(readMode());
    loadCommercialConfiguration();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
